import { useMemo } from 'react';
import { ObjectConfig, ObjectConfigAction, RawObject } from '../../../interfaces/object';
import { NonConfigurableRowStatus } from '../../NonConfigurableRowStatus';
import {
  OBJECT_CONFIG_EDIT_CONFIG_ACTION_DISPLAY_DETAILS,
  OBJECT_CONFIG_VIEW_CONFIG_ACTION_DISPLAY_DETAILS
} from '../../../constants/object-config-actions';
import { getObjectConfigActionsConfirmDialogProps } from '../../../constants/object-config-confirm-dialog-props';
import { EntityActions, EntityActionsProps } from '../../../../../entity-actions/EntityActions';
import { ObjectActionsFactory } from '../../../factories/objects';

export interface ObjectConfigActionsCellProps {
  pipelineId: number;
  isViewMode?: boolean;
  object: ObjectConfig;
  onObjectAction: (updatedObject: ObjectConfig) => void;
  openFieldsSelectionModal: (object: ObjectConfig) => void;
}

export function ObjectConfigActionsCell({
  pipelineId,
  isViewMode,
  object,
  onObjectAction,
  openFieldsSelectionModal
}: ObjectConfigActionsCellProps) {
  // const [obj, setObj] = useState(object);

  const entityActionsProps: EntityActionsProps<ObjectConfigAction, ObjectConfig> = useMemo(() => {
    const actions = isViewMode ? [...object.actions] : [];

    if (object.isEditConfigAllowed && isViewMode) {
      actions.push({
        ...OBJECT_CONFIG_VIEW_CONFIG_ACTION_DISPLAY_DETAILS,
        onClick: () => openFieldsSelectionModal(object)
      });
    }

    if (object.isEditConfigAllowed && !isViewMode) {
      actions.push({
        ...OBJECT_CONFIG_EDIT_CONFIG_ACTION_DISPLAY_DETAILS,
        onClick: () => openFieldsSelectionModal(object)
      });
    }

    return {
      actions,
      entity: object,
      confirmationDialogProps: getObjectConfigActionsConfirmDialogProps(pipelineId)
    };
  }, [isViewMode, object, pipelineId]);

  return (
    <div className='center-flex-row justify-end'>
      {!object.isConfigurable && !isViewMode ? (
        <NonConfigurableRowStatus
          status={object.status}
          reason={object.statusReason}
          hideTooltip={isViewMode}
        />
      ) : null}

      <EntityActions<ObjectConfigAction, ObjectConfig>
        {...entityActionsProps}
        updateEntityOnSuccess={onObjectAction}
        getEntityFromActionResponse={res => ({
          ...object,
          actions: ObjectActionsFactory((res as { actions: RawObject['actions'] }).actions ?? [])
        })}
        menuIconSize={1}
        menuLabel='Object Actions'
      />
    </div>
  );
}
